var map = {
	"./Messages.jpg": 323,
	"./Messages.png": 124,
	"./book.png": 125,
	"./box.png": 126,
	"./chat.png": 127,
	"./chat_01.png": 324,
	"./chat_02.png": 325,
	"./chat_icon.png": 326,
	"./cloud.png": 128,
	"./dashboard.png": 327,
	"./dot.png": 328,
	"./get_started_bg.png": 329,
	"./john.png": 129,
	"./left_leaf.png": 130,
	"./live_chat.png": 131,
	"./mobile.png": 132,
	"./panguin_img_one.png": 133,
	"./panguin_img_three.png": 134,
	"./panguin_img_two.png": 135,
	"./pluse.png": 136,
	"./richard.png": 137,
	"./right_leaf.png": 138,
	"./skyp_1.png": 330,
	"./skyp_2.png": 331,
	"./support_dashboard.jpg": 332,
	"./triangle.png": 139,
	"./video_icon.png": 333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;